<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <h6>{{ formTitle }}</h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end">
        <div class="d-flex gap-2">
          @if (swOrderModule) {
          <!-- Pedido(Masivo) -->
          <app-custom-button [label]="'Ped.Masivo'" [severity]="'primary'" [disabled]="disabledDetail"
            [width]="'6.2rem'" [icon]="'pi pi-user-plus'" (onClick)="openMassiveOrderSelectionModal()">
          </app-custom-button>
          <app-custom-modal #massiveOrderSelection [header]="'Pedido Masivo'" [width]="'80vw'"
            [inputs$]="inputsForMassiveOrderSelectionModals$" [children]="componentMassiveOrderSelection" hidden
            (selectedItems)="handleMassiveOrderSelection($event)">
          </app-custom-modal>
          <!-- Pedido(Manual) -->
          <app-custom-button [label]="'Ped.Manual'" [severity]="'primary'" [disabled]="disabledDetail"
            [width]="'6.2rem'" [icon]="'pi pi-user-edit'" (onClick)="openManualOrderSelectionModal()">
          </app-custom-button>
          <app-custom-modal #manualOrderSelection [header]="'Pedido Manual'" [width]="'80vw'"
            [inputs$]="inputsForManualOrderSelectionModals$" [children]="componentManualOrderSelection" hidden
            (selectedItems)="handleManualOrderSelection($event)">
          </app-custom-modal>
          }
          @if (swOrderModule && this.swDispatchEnabled) {
          <app-custom-button [label]="'Despacho sin pedido'" [severity]="'success'" [disabled]="isButtonDisabled()"
            [width]="'9rem'" (onClick)="openArticleSelectionModal()"></app-custom-button>
          }
          @if (!swOrderModule) {
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
            [width]="'6.5rem'" (onClick)="openArticleSelectionModal()">
          </app-custom-button>
          }
          <app-custom-modal #articleSelection [label]="'Seleccionar'" [header]="'Selección de Artículos'"
            [children]="componentTableSelection" [inputs$]="inputsForArticlesSelection$" [output$]="output$"
            (selectedItems)="handleArticleSelectionAsync($event)" hidden>
          </app-custom-modal>
        </div>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-remission-detail [remissionContract]="remissionModel" [remissionDetailContract]="remissionDetail"
          [swReservation]="swReservation" [costCenterPriceContract]="costCenterPriceContract"
          (updateListDetail)="getRemissionDetailsByRemission()" (isFormView)="getFormView($event)"
          (costCenterPriceRegister)="getCostCenterPriceOpen($event)">
        </app-register-remission-detail>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormOrderView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-manual-order [remissionContract]="remissionModel"
          [remissionDetailFromOrder]="remissionDetailFromOrder" (reloadRemissionContract)="reloadRemission($event)"
          (updateListDetail)="getRemissionDetailsByRemission()" (isFormOrderView)="getFormOrderView($event)">
        </app-register-manual-order>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail" [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onRecoverData)="getRemissionDetailsByRemission()"
        (onPageChange)="onPageChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>
<!-- Precios C.Costos -->
<app-custom-modal #costCenterPriceRegisterModal [label]="'Precios C.Costos - Captura'"
  [header]="'Precios C.Costos - Captura'" [inputs$]="inputsForRegisterModals$" [width]="'50rem'"
  [children]="componentRegisterModal" hidden (params)="getCostCenterPriceRegister($event.costCenterPriceModel)">
</app-custom-modal>

<!-- Captura Horas días -->
<app-custom-modal #captureHoursDaysModal [label]="'Captura Horas/Días'" [header]="'Captura Horas/Días'"
  [inputs$]="inputsForCaptureHoursDaysModals$" [output$]="output$" [width]="'40rem'"
  [breakpoints]="breakpointsForHoursDays" [children]="componentCaptureHoursDaysModal" hidden>
</app-custom-modal>